import { render, staticRenderFns } from "./BaseEditIcon.vue?vue&type=template&id=3ee16c6c"
import script from "./BaseEditIcon.vue?vue&type=script&lang=js"
export * from "./BaseEditIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports